import COLOR from './color';

export const BORDER_RADIUS = '4px';

export const MIN_BUTTON_HEIGHT = '2.75rem';

export const DARKER_SHADOW = COLOR.GRAY_500;
export const SHADOW_COLOR = COLOR.GRAY_300;

export const BOX_SHADOW = {
  TOP: `-1px 0 0.5px ${SHADOW_COLOR}`,
  LEFT: `0 -1px 0.5px ${SHADOW_COLOR}`,
  BOTTOM: `1px 1px 0.5px ${SHADOW_COLOR}`,
  UNDER: `0px 0px 3px ${DARKER_SHADOW}`,
  RIGHT: `0 1px 0.5px ${SHADOW_COLOR}`,
  ALL: `0px 0px 1px ${SHADOW_COLOR}`,
  CARD: '0 0 0.5px rgba(20,20,20, 0.3)',
  INPUT: 'inset 0 1px 2px 0 rgba(0, 0, 0, 0.25)',
};
